import styled from 'styled-components'
import { StyledButton } from '../common/styles/Button'
import { Form } from 'formik'

export const StyledForm = styled(Form)`
   max-width: 400px;
   margin: 0 auto;
`

export const Button = styled(StyledButton)`
  margin-left: 0;
`